/* eslint-disable react/display-name */
import React from 'react';
import { PaginatorContainer, PaginationInfo} from './Paginator.styled';
import { Paginator } from 'primereact/paginator';
import FirstPageIconActive from 'src/assets/images/FirstPageIconActive.svg';
import FirstPageIconInactive from 'src/assets/images/FirstPageIconInactive.svg';
import LastPageIconActive from 'src/assets/images/LastPageIconActive.svg';
import LastPageIconInactive from 'src/assets/images/LastPageIconInactive.svg';
import NextIconActive from 'src/assets/images/NextIconActive.svg';
import NextIconInactive from 'src/assets/images/NextIconInactive.svg';
import PreviousIconActive from 'src/assets/images/PreviousIconActive.svg';
import PreviousIconInactive from 'src/assets/images/PreviousIconInactive.svg';
import {getSelectedPageLinkStyles} from './helperFunctions/index.js';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import {
  createPageLinksTemplate
} from './PageLinksTemplate';

export default function BasicPagination(props) {
    const {margin,
        iPadPaginatorInfoWidth,
        textAlign,
        JustifyContent,
        Display,
        AlignItems,
        alignSelf,
        marginKB,
        marginLeft,
        marginSurgery,
        totalRecords,
        recordsPerPage,
        pageNumber,
        handleChange,
        first,
        flexDirection,
        iPadPaginatorWidth,
        iPadPaginatorJustifyContent,
        mobilePadding,
        ipadWidth,
        paddingBottom,
        paddingTop,
        marginRightKB,
        content,
        id,
        pageLinkSize=5,
        noMarginRight,
        ipadPopupNoMarginRight,
        iPadPaginationPadding,
        linkPadding,
        linkMargin,
        marginPaginationInfo,
        ipadPaginationInfoMargin,
        isFromIndependentProductGuide,
        background,
        width,
        flexGrow
    } = props;
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    
    const pagesInfoTemplate = () => {
        const { t } = useTranslation();
        const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    
        return (
            <PaginationInfo
                id="paginationInfo"
                margin={margin}
                iPadPaginatorInfoWidth={iPadPaginatorInfoWidth}
                ipadPaginationInfoMargin={ipadPaginationInfoMargin}
                textAlign={textAlign}
                JustifyContent={JustifyContent}
                Display={Display}
                AlignItems={AlignItems}
                alignSelf={alignSelf}
                isCondensedView={isCondensedView}
                marginKB={marginKB}
                marginLeft={marginLeft}
                marginSurgery={marginSurgery}
                marginPaginationInfo={marginPaginationInfo}
                flexGrow={flexGrow}
            >
                {isLanguageChanged ? (
                    ` ${totalRecords ? totalRecords : 0} 中 ${
                        totalRecords > 0
                            ? pageNumber * recordsPerPage + 1
                            : 0
                    }  から ${
                        pageNumber * recordsPerPage + recordsPerPage > totalRecords
                            ? totalRecords
                            : pageNumber * recordsPerPage + recordsPerPage
                    } を表示`
                ) : (
                    <>
                        {content ? content : t('pagination.showingCasesText')}{' '}
                        {totalRecords > 0
                            ? pageNumber * recordsPerPage + 1
                            : 0}{' '}
                        {t('pagination.toText')}{' '}
                        {pageNumber * recordsPerPage + recordsPerPage > totalRecords
                            ? totalRecords
                            : pageNumber * recordsPerPage + recordsPerPage}{' '}
                        {t('pagination.ofText')}{' '}
                        {totalRecords ? totalRecords : 0}
                    </>
                )}
            </PaginationInfo>
        );
    };


    const pagesLinksTemplate = createPageLinksTemplate({
        FirstPageIconActive,
        FirstPageIconInactive,
        PreviousIconActive,
        PreviousIconInactive,
        NextIconActive,
        NextIconInactive,
        LastPageIconActive,
        LastPageIconInactive,
        getSelectedPageLinkStyles,
        isCondensedView,
        id
    });
     
    return (
        <PaginatorContainer
            id={id}
            flexDirection={flexDirection}
            iPadPaginationPadding={iPadPaginationPadding}
            background={background}
            iPadPaginatorWidth={iPadPaginatorWidth}
            iPadPaginatorJustifyContent={iPadPaginatorJustifyContent}
            mobilePadding={mobilePadding}
            ipadWidth={ipadWidth}
            marginRight={isCondensedView && window.innerWidth > 1024 && !noMarginRight}
            isCondensedView={isCondensedView}
            paddingBottom={paddingBottom}
            paddingTop={paddingTop}
            marginRightKB={marginRightKB}
            marginSurgery = {marginSurgery}
            ipadPopupNoMarginRight={ipadPopupNoMarginRight}
            linkPadding={linkPadding}
            linkMargin={linkMargin}
            isFromIndependentProductGuide={isFromIndependentProductGuide}
            width={width}
            flexGrow={flexGrow}
        >
            {pagesInfoTemplate()}
            <Paginator
                template={pagesLinksTemplate}
                rows={recordsPerPage}
                totalRecords={totalRecords}
                onPageChange={handleChange}
                first={first}
                pageLinkSize={pageLinkSize ? pageLinkSize : 5}
                alwaysShow
            ></Paginator>
        </PaginatorContainer>
    );
}

BasicPagination.defaultProps = {
    recordsPerPage: 50,
};
